import DashboardIcon from "../assets/images/icons/active/dashboard_white@3x.png";
import InactiveDashboardIcon from "../assets/images/icons/inactive/dashboard dissable@3x.png";
import BulkUpload from "../pages/ExamControllerAssistant/BulkUpload/BulkUpload";
import CertificateList from "../pages/ExamControllerAssistant/Certificate/CertificateList/CertificateList";
import PreviewCertificate from "../pages/ExamControllerAssistant/Certificate/PreviewCertificate/PreviewCertificate";
import ViewCertificate from "../pages/ExamControllerAssistant/Certificate/ViewCertificate/ViewCertificate";

var ExamControllerAssistantRoutes = [
  {
    path: "certificates",
    name: "Certificates",
    element: <CertificateList/>,
    layout: "assistant",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
   {
    path: "bulk-upload",
    name: "Bulk Upload",
    element: <BulkUpload/>,
    layout: "assistant",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  }, 
  {
    path: "view-certificate",
    name: "View Certificate",
    element: <ViewCertificate/>,
    layout: "assistant",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "certificates/preview-certificate/:certificate_id",
    name: "Preview Certificate",
    element: <PreviewCertificate/>,
    layout: "assistant",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
];
export default ExamControllerAssistantRoutes;
